/**
 * NotFound
 */

import './index.less';
import React, {useEffect} from 'react';
import {ActivityIndicator} from 'antd-mobile-v2';

function NotFound(props) {
  console.log('NotFound props:', props);
  const {location} = props;
  useEffect(() => {
    let newLink = `${window.location.protocol}//${window.location.host}${location.pathname}`;
    window.location.replace(newLink);
  }, [location]);
  return <ActivityIndicator toast text="跳转中..." />;

  /*return (
    <div className="app not-found">
      <p><strong>404</strong></p>
      <p>页面不存在, 请返回首页</p>
      <p>Page not found, please return</p>
      <p><Link to={'/'}>返回首页</Link></p>
    </div>
  );*/
}

export default NotFound;
